/* eslint-env jquery */

"use strict";

// Tile-Show renders this marker when the tile cannot be built (e.g. product missing from the search index).
const EMPTY_TILE = ".js-empty-product-tile";
// Add to cart button of a product that is not available in the shopper's zone. It comes from an
// uncached include, so it is reliable even when the page or the tile itself is cached.
const UNAVAILABLE_TILE = "button[data-is-unavailable='true']";
const CAROUSEL_HEADER = ".ahumada-recommendation-header, .ahumada-related-header, .products-carousel-title";

/**
 * Removes from a product carousel the slides whose tile is empty or out of stock. It must run
 * before Swiper is initialized, so the removed slides are not counted as slides or bullets.
 * When no slide is left the carousel wrapper (and its title) is hidden.
 * @param {string|Element|jQuery} container - element that holds the slides
 * @param {string|Element|jQuery} [wrapper] - element to hide when the carousel ends up empty
 * @returns {number} number of removed slides
 */
function pruneProductSlides(container, wrapper) {
    const $container = $(container);
    const $slides = $container.find(".swiper-slide");
    const $hidden = $slides.filter(function () {
        return $(this).find(`${EMPTY_TILE}, ${UNAVAILABLE_TILE}`).length > 0;
    });

    if (!$hidden.length) {
        return 0;
    }

    $hidden.remove();

    if ($hidden.length === $slides.length && wrapper) {
        const $wrapper = $(wrapper);

        $wrapper.addClass("d-none");
        $wrapper.prev(CAROUSEL_HEADER).addClass("d-none").removeClass("d-flex");
    }

    return $hidden.length;
}

module.exports = {
    pruneProductSlides
};
